module.exports = __webpack_public_path__ + "img/service_web_solutions_5.21e86258.jpg";